import React from "react"
import { graphql, Link } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import PageHeader from "../components/pageHeader"

const ProjectsList = styled.ul`
  margin-top: 15px;
  padding: 0;
`

const ProjectsListItem = styled.li`
  list-style: none;
  font-size: 20px;
`

export default function Projects({ data }) {
  const projectsData = data.allMarkdownRemark.nodes

  projectsData.sort((p1, p2) => {
      if (!p1.frontmatter.priority) {
        return 1
      }
      if (!p2.frontmatter.priority) {
        return -1
      }
      return p1.frontmatter.priority - p2.frontmatter.priority
  })

  const projectsListItems = projectsData.map(project => (
    <ProjectsListItem key={project.frontmatter.slug}>
      <Link to={project.frontmatter.slug}>
        {project.frontmatter.title}
      </Link>
    </ProjectsListItem>
  ))

  return (
    <Layout>
      <PageHeader>Projects</PageHeader>
      <p>Some of the projects/apps I have built:</p>
      <ProjectsList>
        {projectsListItems}
      </ProjectsList>
    </Layout>
  )
}

export const pageQuery = graphql`
  query GetProjects {
    allMarkdownRemark {
      nodes {
        frontmatter {
          slug
          title
          priority
        }
      }
    }
  }
`
